import {
    boxesPL,
    situationsPL,
    slidesPL,
    buyHeadersPL,
    authorsPL,
} from "../../pl_resources";

const translationPolish = {
    pl: {
        translation: {
            siteIsNotBeingUsedInfo:
                "Ta strona nie jest już dostępna lub aktywna. Służy wyłącznie do celów prezentacyjnych!",
            navigation: {
                examples: {
                    name: "Przykłady użycia",
                    link: "przyklady",
                },
                about: {
                    name: "O niezbędniku",
                    link: "planer",
                },
                contact: {
                    name: "Kontakt",
                    link: "kontakt",
                },
                newsletter: {
                    name: "Newsletter",
                    link: "newsletter",
                },
                changeLanguage: {
                    name: "Zmień Język",
                },
            },

            externalLinks: {
                shop: "https://get-creative-everyday-demo.netlify.app/",
            },

            boxes: boxesPL,

            quotes: {
                possible: "Czy to możliwe?",
                organiser: "Organizator, inspirator i time-saver w jednym?",
                teachers: "Dedykowany nauczycielom angielskiego?",
                tool: "Already fully in English?",
            },

            situations: situationsPL,

            slides: slidesPL,

            buyHeaders: buyHeadersPL,

            authorsDescriptions: authorsPL,

            atoms: {
                header: `<b>Kalendarz i planner</b> z gotowymi pomysłami na zajęcia z języka angielskiego
                <br />
                <b>dla młodszych dzieci</b>`,

                buyNow: "Kup teraz",

                signUp: "Zapisz się",

                hereYouAre: "Oto on",

                creativityBoost:
                    "Zapewniamy nauczycielską kreatywność każdego dnia!",

                isPlannerGoodForYou:
                    "Czy Get Creative Every Day na pewno jest dla Ciebie?",

                checkItOut: "Sprawdź!",

                meetExpectations:
                    "Nadal poszukujesz idealnego plannera, który spełni wszystkie Twoje oczekiwania?",

                youFoundIt: "Masz go tutaj!",

                fromTeachersToTeachers: "Od nauczycieli dla nauczycieli",

                authorsCircle: {
                    content:
                        "Do współpracy nad treściami zaprosiliśmy nauczycieli języka angielskiego, którzy zaproponowali pomysły, wskazówki i tipy oparte na ich codziennej praktyce. Część materiałów pochodzi <b>także z zasobów</b>",
                    span: "Czasopisma Get Creative",
                },

                authorsContribution: "Część autorów którzy wnieśli swój wkład:",

                notEnoughInfo: "Nadal za mało informacji?",
                signUpForNewsletter:
                    "Zapisz się na nasz newsletter by dostać ich więcej!",

                yourEmail: "Twój adres email",

                messages: {
                    emailSaved: "Email został zapisany!",
                    emailNotSaved:
                        "Email nie został zapisany. Spróbuj ponownie później.",
                    emailExist: "Email jest już zarejestrowany!",
                },

                from: "z",

                polish: "polski",
                english: "english",
                spanish: "española",
            },
        },
    },
};

export default translationPolish;
